__turbopack_context__.v({
  "list": "ErrorGone-module-scss-module__HKUoeW__list",
  "listItem": "ErrorGone-module-scss-module__HKUoeW__listItem",
  "section": "ErrorGone-module-scss-module__HKUoeW__section",
  "styledLink": "ErrorGone-module-scss-module__HKUoeW__styledLink",
  "titlePrimary": "ErrorGone-module-scss-module__HKUoeW__titlePrimary",
  "unorderedList": "ErrorGone-module-scss-module__HKUoeW__unorderedList",
});
